export default "__VITE_ASSET__d3438d17__"